// extracted by mini-css-extract-plugin
export default {"hist":"UserPreview_hist__79QYD","avatar":"UserPreview_avatar__3s2In","avatarContainer":"UserPreview_avatarContainer__798Kd","avatarSignature":"UserPreview_avatarSignature__2zgSC"};